var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"dense":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider'),_vm._l((_vm.tabs),function(v,i){return _c('v-tab',{key:i,attrs:{"to":v.to}},[_vm._v(" "+_vm._s(v.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }